export default {
  computed: {
    todayIsoDate() {
      const now = new Date();
      const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
      return local.toISOString().slice(0, 10);
    },
    contractMovementDate() {
      return this.contractDateFrom(this.contractNote());
    },
    movementDateLocked() {
      return !!this.contractMovementDate;
    },
    movementDateIsFuture() {
      return !!this.contractMovementDate && this.contractMovementDate > this.todayIsoDate;
    },
    contractDateHint() {
      const note = this.contractNote();
      const date = this.contractMovementDate;
      if (!note || !date) {
        return "";
      }
      const key = note.direction === "outbound"
        ? "STOCK.SALES.DATE_FOLLOWS_LOADING"
        : "STOCK.RECEIPTS.DATE_FOLLOWS_UNLOADING";
      return this.$t(key, { code: note.code, date });
    },
    issueAsOfDate() {
      const date = this.document && this.document.action_date;
      if (!date || date > this.todayIsoDate) {
        return this.todayIsoDate;
      }
      return date;
    },
  },
  methods: {
    contractNote(document) {
      const source = document || this.document;
      if (!source) {
        return null;
      }
      return source.delivery_note_summary || source.delivery_note || null;
    },
    contractDateFrom(note) {
      if (!note) {
        return null;
      }
      const raw = note.direction === "outbound" ? note.etd_date : note.eta_date;
      return raw ? String(raw).slice(0, 10) : null;
    },
    withContractMovementDate(document) {
      const contractDate = this.contractDateFrom(this.contractNote(document));
      if (!contractDate) {
        return document;
      }
      return {
        ...document,
        action_date: contractDate,
      };
    },
  },
};
